/** Rupees on screen, from the integer paise the server speaks.
 *
 * Two formats, because two different questions are being answered:
 *
 *   * a PRICE is always a round number (₹250, ₹4,000) and showing
 *     ₹250.00 would imply a precision the pricing does not have;
 *   * a COST is whatever the tokens happened to add up to, and rounding
 *     ₹1.06 to ₹1 — or worse, 30 paise to ₹0 — turns a real number into
 *     one that looks broken.
 *
 * Both group in the Indian convention (1,50,000), which is what the
 * people reading these screens expect to see.
 */
const GROUPED = new Intl.NumberFormat("en-IN");
const WITH_PAISE = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Paise → "₹250". For prices, which are whole rupees by construction. */
export function rupees(minor: number): string {
  return `₹${GROUPED.format(Math.round(minor / 100))}`;
}

/** Paise → "₹1.06" / "₹352". Keeps the paise only when there are any, so
 *  a column of costs does not carry ".00" on every row. */
export function rupeeCost(minor: number): string {
  const whole = minor % 100 === 0;
  return `₹${(whole ? GROUPED : WITH_PAISE).format(minor / 100)}`;
}
